import api from "./api";

export const validateStopMerge = async (
  depotCode,
  routeId,
  parcels,
  checkOpenRequests,
  shopUnsuitable,
  splitStop
) => {
  const { data } = await api.post(
    `/depot/${depotCode}/route/${routeId}/stop/validate`,
    null,
    {
      parcel: parcels,
      checkOpenRequests,
      shopUnsuitable,
      splitStop,
    }
  );

  return data;
};
